import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import { NS } from '@/constants';
import { CallToActionKind } from '@/types';
import { getAvailableAlerts } from '@/utils/primeurUtils';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import PrimeurUserNoData from '@/components/primeurAlert/PrimeurUserNoData';
import DesignationList from '@/components/primeurAlert/DesignationList';
import ReturnButton from '@/components/account/ReturnButton';

import styles from './PrimeurAlert.module.scss';
import { PRIMEUR_TABS } from '@/constants/primeur';
import { URLS } from '@/constants/urls';

export const PrimeurAlert = ({ designations, alertList = [], onAlertMe, onReturn, isMobileOrTablet }) => {
  const { t } = useTranslation(NS.COMMON);
  const designationsList = { ...designations };
  const [designationsChecked, setDesignationsChecked] = useState({});
  const router = useRouter();
  const availableAlerts = getAvailableAlerts(designations, alertList);
  const counter = availableAlerts.length;

  useEffect(() => {
    if (alertList.length > 0) {
      Object.keys(designationsList).forEach((key) => {
        designationsList[key] = designationsList[key].filter(
          (product) => alertList.includes(product.partnumber)
        );
      });

      setDesignationsChecked(designationsList);
    }
  }, [alertList]);

  const handleDeleteAllAlert = () => {
    onAlertMe(availableAlerts, undefined, true);
  };

  const handleCreateAlert = () => {
    router.push(PRIMEUR_TABS.SEARCH);
  };

  return (
    <div className={styles.container} data-rbf="primeur-alert">
      {isMobileOrTablet &&
        <ReturnButton onClick={() => onReturn()} />
      }
      <div className={styles.header}>
        <div className={styles['title-and-counter']}>
          <div className={styles.title}>{t('alert.alerts')}</div>
          <div className={styles.counter}>{counter}</div>
        </div>
        {counter > 0 && (
          <CallToActionContainer
            kind={CallToActionKind.SECONDARY}
            customClass={styles.button}
            onClick={() => handleDeleteAllAlert()}
          >
            {t('alert.deleteAll')}
          </CallToActionContainer>
        )}
      </div>
      {counter > 0 ? (
        <div className={styles.content}>
          <DesignationList
            designations={designationsChecked}
            alertList={alertList}
            onAlertMe={onAlertMe}
            isPrimeurAlert
          />
        </div>
      ) : (
        <PrimeurUserNoData
          img={URLS.PRIMEUR_NOTIF}
          alt="notification"
          text={t('alert.noAlert')}
          onClick={handleCreateAlert}
          labelBtn={t('alert.createAnAlert')}
        />
      )}
    </div>
  );
};

PrimeurAlert.propTypes = {
  designations: PropTypes.object.isRequired,
  alertList: PropTypes.array,
  onAlertMe: PropTypes.func,
  onReturn: PropTypes.func,
  isMobileOrTablet: PropTypes.bool
};

export default PrimeurAlert;
